/**
 * WHOSE BACKGROUNDS does a gift offer? The pricelist the customer is shopping
 * FROM, not the one the gift is booked against.
 *
 * A standalone gift order is always booked against the school's GIFT pricelist
 * (HolidayBuilder's mutation; its $0 option comes from there), so the order
 * package alone cannot tell a senior from a second-grader. The senior arrived
 * with `?pid=<senior pricelist>`, and that pricelist carries the senior
 * background set -- 76 studio backdrops against the gift pricelist's 104
 * generic ones, measured 2026-10-20. The shelf already read `pid` for this;
 * the edit page did not, so a senior chose a background from the senior set
 * on the shelf and was handed the gift set on the very next screen (Katie,
 * 2026-10-20). `pid` now travels in the edit URL and both screens ask here.
 *
 * In order of authority:
 *   1. `pid`                     the pricelist being browsed (URL)
 *   2. `orderPackage.packageId`  the package the gift is attached to -- the
 *                                senior pricelist itself when a gift is added
 *                                from inside a senior order
 *   3. `giftPricelist.id`        the school's gift pricelist, the floor
 *
 * Not every way into the edit page carries `pid`: the cart's edit links and
 * the free-item picker do not, because by then nothing is being browsed. From
 * there (2) decides -- the senior/fall/sports set for a gift inside such an
 * order, and the gift set for a standalone gift, which has no other pricelist
 * to name. Carrying the browsed pricelist onto the order package itself would
 * close that gap; it is not done here.
 */
export default function backgroundsPricelistId({ pid = null, orderPackage = null, giftPricelist = null } = {}) {
  return pid || orderPackage?.packageId || giftPricelist?.id || null;
}
